'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, TextPassage } from '@petsmart-ui/sparky';
import Link from 'next/link';
import { SECONDARY_BUTTON_STYLE, TARGET_BLANK } from '../../constants';
import { ColoredTextLink } from '../ColoredTextLink';
import type { FaqStoreCardProps } from './types';
import './FaqStoreCards.scss';
function FaqStoreCard(t0) {
  const $ = _c(22);
  const {
    cityState,
    address,
    badges,
    phoneNumber,
    cta
  } = t0;
  const t1 = cityState?.link?.webUrl ?? "";
  let t2;
  if ($[0] !== cityState.actionText || $[1] !== t1) {
    t2 = <ColoredTextLink className="faq-store-card__headline" href={t1} color="Dark Grey">{cityState.actionText}</ColoredTextLink>;
    $[0] = cityState.actionText;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== address) {
    t3 = <TextPassage>{address}</TextPassage>;
    $[3] = address;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = `tel:${phoneNumber}`;
  let t5;
  if ($[5] !== phoneNumber || $[6] !== t4) {
    t5 = <ColoredTextLink href={t4} color="Dark Grey">{phoneNumber}</ColoredTextLink>;
    $[5] = phoneNumber;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3 || $[9] !== t5) {
    t6 = <div className="faq-store-card__text">{t3}{t5}</div>;
    $[8] = t3;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== badges) {
    t7 = badges?.map(_temp);
    $[11] = badges;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t7) {
    t8 = <div className="faq-store-card__badges">{t7}</div>;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== cta) {
    t9 = cta && <Link prefetch={false} href={cta?.link?.webUrl ?? ""} target={TARGET_BLANK}><Button variant={SECONDARY_BUTTON_STYLE} text={cta.text} size="sm" /></Link>;
    $[15] = cta;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t2 || $[18] !== t6 || $[19] !== t8 || $[20] !== t9) {
    t10 = <div className="faq-store-card">{t2}{t6}{t8}{t9}</div>;
    $[17] = t2;
    $[18] = t6;
    $[19] = t8;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  return t10;
}
function _temp(t0, index) {
  const {
    text
  } = t0;
  return <TextPassage className="faq-store-card__badge" size="sm" key={index}>{text}</TextPassage>;
}
export function FaqStoreCards(t0) {
  const $ = _c(4);
  const {
    answers
  } = t0;
  let t1;
  if ($[0] !== answers) {
    t1 = answers.map(_temp2);
    $[0] = answers;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <li className="faq-store-cards">{t1}</li>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp2(card, index) {
  return <FaqStoreCard key={index} {...card} />;
}